import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PropertyProvider } from "@/context/PropertyContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Resumen from "@/pages/Resumen";
import Dashboard from "@/pages/Dashboard";
import Calendario from "@/pages/Calendario";
import Properties from "@/pages/Properties";
import Tenants from "@/pages/Tenants";
import TenantDetail from "@/pages/TenantDetail";
import Contracts from "@/pages/Contracts";
import Payments from "@/pages/Payments";
import Expenses from "@/pages/Expenses";
import Incidents from "@/pages/Incidents";
import Irpf from "@/pages/Irpf";
import Plantilla from "@/pages/Plantilla";
import Import from "@/pages/Import";
import Admin from "@/pages/Admin";
import Auditoria from "@/pages/Auditoria";
import Account from "@/pages/Account";
import Backups from "@/pages/Backups";
import Statistics from "@/pages/Statistics";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        element={
          <Protected>
            <PropertyProvider>
              <Layout />
            </PropertyProvider>
          </Protected>
        }
      >
        <Route path="/resumen" element={<Resumen />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/calendario" element={<Calendario />} />
        <Route path="/pisos" element={<Properties />} />
        <Route path="/inquilinos" element={<Tenants />} />
        <Route path="/inquilinos/:id" element={<TenantDetail />} />
        <Route path="/contratos" element={<Contracts />} />
        <Route path="/pagos" element={<Payments />} />
        <Route path="/gastos" element={<Expenses />} />
        <Route path="/incidencias" element={<Incidents />} />
        <Route path="/irpf" element={<Irpf />} />
        <Route path="/plantilla" element={<Plantilla />} />
        <Route path="/importar" element={<Import />} />
        <Route path="/cuenta" element={<Account />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/auditoria" element={<Auditoria />} />
        <Route path="/backups" element={<Backups />} />
        <Route path="/estadisticas" element={<Statistics />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}
